import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetAllDidsLocal({ commit }, list) {
    let url = `did/company/list?order_dir=desc&order_by=created_on&is_toll_free=${list.is_toll_free}`
    return axios({
      url: url,
      params: {
        page: list.page ? list.page : '',
        per_page: list.perPage ? list.perPage : 10,
        order_by: list.order_by,
        order_dir: list.order_dir,
        did: list.did ? `*${list.did}*` : ""
      },
      method: "GET"
    }).then(res => {
      return res.data.payload;
    });
  },


  GetAllDids({ commit }, list) {
    console.log("1111", list)
    return axios({
      url: `/did/company/list`,
      params: {
        page: list.page ? list.page : '',
        per_page: list.perPage ? list.perPage : 10,
        did: list.did ? '*' + list.did + '*' : '',
        type: list.type ? list.type : '',
        user_id: list.user_id || null,
        is_toll_free: list.is_toll_free || null,
      },
      method: "GET"
    }).then(res => {
      return res.data.payload;
    });
  },
  GetAllDidsAni({ commit }, list) {
    if(list.per_page) {
      return axios({
        url: "/did/company/list",
        params: {
          per_page: list.perPage ? list.perPage : 10,
        },
        method: "GET"
      }).then(res => {
        return res.data.payload;
      });
    } else {
      return axios({
        url: "/did/company/list?did_type=ANI",
        params: {},
        method: "GET"
      }).then(res => {
        return res.data.payload;
      });
    }

  },
  GetSearchedDids({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/did/list?order_by=created_on&order_dir=desc",
        params: {
          is_assigned: list.is_assigned === 'false' ? 'false' : '',
          country_uuid: list.countryId || '',
          type: list.type || '',
          did_type: list.did_type || '',
          area_code: list.areaCode || '',
          page: list.page || 0,
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetFreeDids({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/did/free/list?order_by=created_on&order_dir=desc",
        params: {
          country_uuid: list.countryId ? list.countryId : '',
          type: list.type ? list.type : '',
          did_type: list.did_type ? list.did_type : '',
          area_code: list.areaCode ? list.areaCode : ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetSearchedDid({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/did/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  getAllSearchedDid({ commit }, list) {
    return axios({
      url: "/did/search",
      params: {
        npa: list.npa || '',
        state: list.state || '',
        lata: list.lata || '',
        pattern: list.pattern || '',
        count: list.count || 10,
      },
      method: "GET"
    }).then(res => {
      return res.data.payload;
    });
  },
  getTfSearchedDid({ commit }, list) {
    return axios({
      url: "/did/tf/search",
      params: {
        pattern: list.pattern || '',
        count: list.count || 10,
      },
      method: "GET"
    }).then(res => {
      return res.data.payload;
    });
  },
  DeleteDid({ commit }, did) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/" + did,
        method: "DELETE"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  AssignDid({ commit }, did) {
    return axios({
      url: "/did/" + did.did + '/assign',
      data: did.companyId,
      method: "PATCH"
    }).then(res => {
      return res.data.payload;
    });
  },
  AssignDidToUser({ commit }, did) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/" + did.did,
        data: did.data,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  EditDid({ commit }, did) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/" + did.did,
        data: did.newDid,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  ImportDid({ commit }, form) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/import",
        data: form,
        method: "POST"
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  ImportDidKannel({ commit }, form) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/kannel/import",
        data: form,
        method: "POST"
      }).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  GetImportedLog({ commit }, list) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/kannel/import/log',
        params: {
          order_by: list.order_by || 'created_on',
          order_dir: list.order_dir || 'desc',
          page: list.page || 0,
          per_page: list.per_page || 10
        },
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err.response.data)
      })
    })
  },
  NewCallFlow({ commit }, callflow) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/call_workflow",
        data: callflow,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  buyDid({ commit }, data) {
    return axios({
      url: "/did/order",
      data: data,
      method: "POST",
    })
  },
  buyTfDid({ commit }, data) {
    return axios({
      url: "/did/tf/order",
      data: data,
      method: "POST",
    })
  },
  GetSuppressedNumbers({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/suppressed_number/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          number: list.number ? '*' + list.number + '*' : ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  DeleteSuppressedNumber({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/suppressed_number/" + id,
        method: "DELETE"
      }).then(res => {
        resolve();
      });
    });
  },
  getStateList({ commit }) {
    return axios({
      url: "/state/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  getLataList({ commit }) {
    return axios({
      url: "/lata/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  getNpaList({ commit }) {
    return axios({
      url: "/npa/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  getTfPrefixList({ commit }) {
    return axios({
      url: "/tf_prefix/list",
      method: "GET"
    }).then(res => {
      return res.data.payload;
    })
  },
  disconnectTfPrefixList({ }, data) {
    return axios({
      url: "/did/tf/disconnect",
      data: data,
      method: "POST",
    }).then(res => {
      return res.data.payload;
    })
  },
  disconnectPrefixList({ }, data) {
    return axios({
      url: "/did/disconnect",
      data: data,
      method: "POST",
    }).then(res => {
      return res.data.payload;
    })
  },
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
